import { render, staticRenderFns } from "./PerformanceProfileDialog.vue?vue&type=template&id=7839ab14"
import script from "./PerformanceProfileDialog.vue?vue&type=script&lang=js"
export * from "./PerformanceProfileDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports